// AUTO-GENERATED FILE. DO NOT EDIT MANUALLY.
// Run: npm run generate:components

import { lazyWithRetry } from "./lazyWithRetry";

const AccessModule = lazyWithRetry(() => import("../Pages/AccessModule/AccessModule.js"));
const AccessModuleDetails = lazyWithRetry(() => import("../Pages/AccessModule/AccessModuleDetails.js"));
const InputAccessModule = lazyWithRetry(() => import("../Pages/AccessModule/InputAccessModule.js"));
const UpdateAccessModule = lazyWithRetry(() => import("../Pages/AccessModule/UpdateAccessModule.js"));
const AccountReportsHub = lazyWithRetry(() => import("../Pages/AccountReports/AccountReportsHub.js"));
const BalanceConfirmations = lazyWithRetry(() => import("../Pages/AccountReports/BalanceConfirmations.js"));
const BalanceSheet = lazyWithRetry(() => import("../Pages/AccountReports/BalanceSheet.js"));
const BankStatement = lazyWithRetry(() => import("../Pages/AccountReports/BankStatement.js"));
const CashBook = lazyWithRetry(() => import("../Pages/AccountReports/CashBook.js"));
const CashFlow = lazyWithRetry(() => import("../Pages/AccountReports/CashFlow.js"));
const Consolidated = lazyWithRetry(() => import("../Pages/AccountReports/Consolidated.js"));
const DayBook = lazyWithRetry(() => import("../Pages/AccountReports/DayBook.js"));
const Expenses = lazyWithRetry(() => import("../Pages/AccountReports/Expenses.js"));
const GlParity = lazyWithRetry(() => import("../Pages/AccountReports/GlParity.js"));
const OpeningBalance = lazyWithRetry(() => import("../Pages/AccountReports/OpeningBalance.js"));
const PartyOpeningBalance = lazyWithRetry(() => import("../Pages/AccountReports/PartyOpeningBalance.js"));
const PayablesAging = lazyWithRetry(() => import("../Pages/AccountReports/PayablesAging.js"));
const PaymentRegister = lazyWithRetry(() => import("../Pages/AccountReports/PaymentRegister.js"));
const ProfitLoss = lazyWithRetry(() => import("../Pages/AccountReports/ProfitLoss.js"));
const Ratios = lazyWithRetry(() => import("../Pages/AccountReports/Ratios.js"));
const ReceiptRegister = lazyWithRetry(() => import("../Pages/AccountReports/ReceiptRegister.js"));
const StockValuation = lazyWithRetry(() => import("../Pages/AccountReports/StockValuation.js"));
const SupplierLedger = lazyWithRetry(() => import("../Pages/AccountReports/SupplierLedger.js"));
const TrialBalance = lazyWithRetry(() => import("../Pages/AccountReports/TrialBalance.js"));
const KeyPersonRisk = lazyWithRetry(() => import("../Pages/Admin/KeyPersonRisk.js"));
const ScheduledJobs = lazyWithRetry(() => import("../Pages/Admin/ScheduledJobs.js"));
const UsageAnalytics = lazyWithRetry(() => import("../Pages/Admin/UsageAnalytics.js"));
const Agent = lazyWithRetry(() => import("../Pages/Agent/Agent.js"));
const InputAgent = lazyWithRetry(() => import("../Pages/Agent/InputAgent.js"));
const UpdateAgent = lazyWithRetry(() => import("../Pages/Agent/UpdateAgent.js"));
const AccountsApprovals = lazyWithRetry(() => import("../Pages/Approvals/AccountsApprovals.js"));
const AdjustmentApprovalsSection = lazyWithRetry(() => import("../Pages/Approvals/AdjustmentApprovalsSection.js"));
const CreditOverrideApprovals = lazyWithRetry(() => import("../Pages/Approvals/CreditOverrideApprovals.js"));
const PendingApprovals = lazyWithRetry(() => import("../Pages/Approvals/PendingApprovals.js"));
const Bank = lazyWithRetry(() => import("../Pages/Bank/Bank.js"));
const InputBank = lazyWithRetry(() => import("../Pages/Bank/InputBank.js"));
const UpdateBank = lazyWithRetry(() => import("../Pages/Bank/UpdateBank.js"));
const BankReconciliation = lazyWithRetry(() => import("../Pages/Banking/BankReconciliation.js"));
const ChequeRegister = lazyWithRetry(() => import("../Pages/Banking/ChequeRegister.js"));
const PaymentRun = lazyWithRetry(() => import("../Pages/Banking/PaymentRun.js"));
const BlouseStitchDetail = lazyWithRetry(() => import("../Pages/BlouseStitch/BlouseStitchDetail.js"));
const BlouseStitchList = lazyWithRetry(() => import("../Pages/BlouseStitch/BlouseStitchList.js"));
const InputBlouseStitch = lazyWithRetry(() => import("../Pages/BlouseStitch/InputBlouseStitch.js"));
const BusinessUnit = lazyWithRetry(() => import("../Pages/BusinessUnit/BusinessUnit.js"));
const BulkUpdateCatalogue = lazyWithRetry(() => import("../Pages/Catalogue/BulkUpdateCatalogue.js"));
const Catalogue = lazyWithRetry(() => import("../Pages/Catalogue/Catalogue.js"));
const DetailsCatalogue = lazyWithRetry(() => import("../Pages/Catalogue/DetailsCatalogue.js"));
const InputCatalogue = lazyWithRetry(() => import("../Pages/Catalogue/InputCatalogue.js"));
const UpdateCatalogue = lazyWithRetry(() => import("../Pages/Catalogue/UpdateCatalogue.js"));
const CatalogueDescription = lazyWithRetry(() => import("../Pages/CatalogueDescription/CatalogueDescription.js"));
const InputCatalogueDescription = lazyWithRetry(() => import("../Pages/CatalogueDescription/InputCatalogueDescription.js"));
const CatalogueMatching = lazyWithRetry(() => import("../Pages/CatalogueMatching/CatalogueMatching.js"));
const CatalogueMatchingApprovals = lazyWithRetry(() => import("../Pages/CatalogueMatching/CatalogueMatchingApprovals.js"));
const DetailsCatalogueMatching = lazyWithRetry(() => import("../Pages/CatalogueMatching/DetailsCatalogueMatching.js"));
const InputCatalogueMatching = lazyWithRetry(() => import("../Pages/CatalogueMatching/InputCatalogueMatching.js"));
const UpdateCatalogueMatching = lazyWithRetry(() => import("../Pages/CatalogueMatching/UpdateCatalogueMatching.js"));
const CatalogueSaleColours = lazyWithRetry(() => import("../Pages/CatalogueSaleColours/CatalogueSaleColours.js"));
const DetailsCatalogueSaleColour = lazyWithRetry(() => import("../Pages/CatalogueSaleColours/DetailsCatalogueSaleColour.js"));
const InputCatalogueSaleColour = lazyWithRetry(() => import("../Pages/CatalogueSaleColours/InputCatalogueSaleColour.js"));
const UpdateCatalogueSaleColour = lazyWithRetry(() => import("../Pages/CatalogueSaleColours/UpdateCatalogueSaleColour.js"));
const ChangePassword = lazyWithRetry(() => import("../Pages/ChangePassword/ChangePassword.js"));
const DashboardScopeCard = lazyWithRetry(() => import("../Pages/ChangePassword/DashboardScopeCard.js"));
const TaxCompliance = lazyWithRetry(() => import("../Pages/Compliance/TaxCompliance.js"));
const AddSimilarCostDesign = lazyWithRetry(() => import("../Pages/CostDesign/AddSimilarCostDesign.js"));
const CostDesign = lazyWithRetry(() => import("../Pages/CostDesign/CostDesign.js"));
const DetailsCostDesign = lazyWithRetry(() => import("../Pages/CostDesign/DetailsCostDesign.js"));
const InputCostDesign = lazyWithRetry(() => import("../Pages/CostDesign/InputCostDesign.js"));
const UpdateCostDesign = lazyWithRetry(() => import("../Pages/CostDesign/UpdateCostDesign.js"));
const CreditNoteDetail = lazyWithRetry(() => import("../Pages/CreditNote/CreditNoteDetail.js"));
const CreditNoteList = lazyWithRetry(() => import("../Pages/CreditNote/CreditNoteList.js"));
const InputCreditNote = lazyWithRetry(() => import("../Pages/CreditNote/InputCreditNote.js"));
const PrintCreditNote = lazyWithRetry(() => import("../Pages/CreditNote/PrintCreditNote.js"));
const UpdateCreditNote = lazyWithRetry(() => import("../Pages/CreditNote/UpdateCreditNote.js"));
const AgingChart = lazyWithRetry(() => import("../Pages/Dashboard/AgingChart.js"));
const Dashboard = lazyWithRetry(() => import("../Pages/Dashboard/Dashboard.js"));
const DashboardCard = lazyWithRetry(() => import("../Pages/Dashboard/DashboardCard.js"));
const GoodsReturnChart = lazyWithRetry(() => import("../Pages/Dashboard/GoodsReturnChart.js"));
const InventoryStageChart = lazyWithRetry(() => import("../Pages/Dashboard/InventoryStageChart.js"));
const LoomPicksChart = lazyWithRetry(() => import("../Pages/Dashboard/LoomPicksChart.js"));
const SalesTrendChart = lazyWithRetry(() => import("../Pages/Dashboard/SalesTrendChart.js"));
const TopClientsTable = lazyWithRetry(() => import("../Pages/Dashboard/TopClientsTable.js"));
const YarnRunwayChart = lazyWithRetry(() => import("../Pages/Dashboard/YarnRunwayChart.js"));
const YarnStockChart = lazyWithRetry(() => import("../Pages/Dashboard/YarnStockChart.js"));
const DebitNoteDetail = lazyWithRetry(() => import("../Pages/DebitNote/DebitNoteDetail.js"));
const DebitNoteList = lazyWithRetry(() => import("../Pages/DebitNote/DebitNoteList.js"));
const InputDebitNote = lazyWithRetry(() => import("../Pages/DebitNote/InputDebitNote.js"));
const PrintDebitNote = lazyWithRetry(() => import("../Pages/DebitNote/PrintDebitNote.js"));
const DefectCodes = lazyWithRetry(() => import("../Pages/Defect/DefectCodes.js"));
const DefectPareto = lazyWithRetry(() => import("../Pages/Defect/DefectPareto.js"));
const AddSimilarDesign = lazyWithRetry(() => import("../Pages/Design/AddSimilarDesign.js"));
const BulkUpdateDesigns = lazyWithRetry(() => import("../Pages/Design/BulkUpdateDesigns.js"));
const Design = lazyWithRetry(() => import("../Pages/Design/Design.js"));
const DesignApprovals = lazyWithRetry(() => import("../Pages/Design/DesignApprovals.js"));
const DetailsDesign = lazyWithRetry(() => import("../Pages/Design/DetailsDesign.js"));
const InputDesign = lazyWithRetry(() => import("../Pages/Design/InputDesign.js"));
const SampleTrialCard = lazyWithRetry(() => import("../Pages/Design/SampleTrialCard.js"));
const UpdateDesign = lazyWithRetry(() => import("../Pages/Design/UpdateDesign.js"));
const ArticleRenderer = lazyWithRetry(() => import("../Pages/Docs/ArticleRenderer.js"));
const Docs = lazyWithRetry(() => import("../Pages/Docs/Docs.js"));
const DyeingDetail = lazyWithRetry(() => import("../Pages/Dyeing/DyeingDetail.js"));
const DyeingList = lazyWithRetry(() => import("../Pages/Dyeing/DyeingList.js"));
const InputDyeing = lazyWithRetry(() => import("../Pages/Dyeing/InputDyeing.js"));
const DyeingRecipeDetail = lazyWithRetry(() => import("../Pages/DyeingRecipe/DyeingRecipeDetail.js"));
const DyeingRecipes = lazyWithRetry(() => import("../Pages/DyeingRecipe/DyeingRecipes.js"));
const InputDyeingRecipe = lazyWithRetry(() => import("../Pages/DyeingRecipe/InputDyeingRecipe.js"));
const UpdateDyeingRecipe = lazyWithRetry(() => import("../Pages/DyeingRecipe/UpdateDyeingRecipe.js"));
const EfficiencyReport = lazyWithRetry(() => import("../Pages/EfficiencyReport/EfficiencyReport.js"));
const EfficiencyReportList = lazyWithRetry(() => import("../Pages/EfficiencyReport/EfficiencyReportList.js"));
const OperatorPerformance = lazyWithRetry(() => import("../Pages/EfficiencyReport/OperatorPerformance.js"));
const Firm = lazyWithRetry(() => import("../Pages/Firm/Firm.js"));
const FirmBankAccounts = lazyWithRetry(() => import("../Pages/Firm/FirmBankAccounts.js"));
const InputFirm = lazyWithRetry(() => import("../Pages/Firm/InputFirm.js"));
const UpdateFirm = lazyWithRetry(() => import("../Pages/Firm/UpdateFirm.js"));
const FlowBoard = lazyWithRetry(() => import("../Pages/FlowBoard/FlowBoard.js"));
const EwayRegister = lazyWithRetry(() => import("../Pages/GSTReports/EwayRegister.js"));
const GSTR1Report = lazyWithRetry(() => import("../Pages/GSTReports/GSTR1Report.js"));
const GSTR2Report = lazyWithRetry(() => import("../Pages/GSTReports/GSTR2Report.js"));
const GSTR3BReport = lazyWithRetry(() => import("../Pages/GSTReports/GSTR3BReport.js"));
const GSTR9Report = lazyWithRetry(() => import("../Pages/GSTReports/GSTR9Report.js"));
const GSTReconciliation = lazyWithRetry(() => import("../Pages/GSTReports/GSTReconciliation.js"));
const GSTReportPage = lazyWithRetry(() => import("../Pages/GSTReports/GSTReportPage.js"));
const GSTReportsHub = lazyWithRetry(() => import("../Pages/GSTReports/GSTReportsHub.js"));
const TdsTcsRegister = lazyWithRetry(() => import("../Pages/GSTReports/TdsTcsRegister.js"));
const DownloadButtonGroup = lazyWithRetry(() => import("../Pages/GSTReports/components/DownloadButtonGroup.js"));
const GSTReportFilters = lazyWithRetry(() => import("../Pages/GSTReports/components/GSTReportFilters.js"));
const Harness = lazyWithRetry(() => import("../Pages/Harness/Harness.js"));
const InputHarness = lazyWithRetry(() => import("../Pages/Harness/InputHarness.js"));
const UpdateHarness = lazyWithRetry(() => import("../Pages/Harness/UpdateHarness.js"));
const Home = lazyWithRetry(() => import("../Pages/Home/Home.js"));
const HsnCode = lazyWithRetry(() => import("../Pages/HsnCode/HsnCode.js"));
const InputHsnCode = lazyWithRetry(() => import("../Pages/HsnCode/InputHsnCode.js"));
const UpdateHsnCode = lazyWithRetry(() => import("../Pages/HsnCode/UpdateHsnCode.js"));
const BulkPrintInternalTransfer = lazyWithRetry(() => import("../Pages/InternalTransfer/BulkPrintInternalTransfer.js"));
const InputInternalTransfer = lazyWithRetry(() => import("../Pages/InternalTransfer/InputInternalTransfer.js"));
const InputInternalTransferFromPO = lazyWithRetry(() => import("../Pages/InternalTransfer/InputInternalTransferFromPO.js"));
const InternalTransferDetail = lazyWithRetry(() => import("../Pages/InternalTransfer/InternalTransferDetail.js"));
const InternalTransfers = lazyWithRetry(() => import("../Pages/InternalTransfer/InternalTransfers.js"));
const PrintInternalTransfer = lazyWithRetry(() => import("../Pages/InternalTransfer/PrintInternalTransfer.js"));
const UpdateInternalTransfer = lazyWithRetry(() => import("../Pages/InternalTransfer/UpdateInternalTransfer.js"));
const DesignInventory = lazyWithRetry(() => import("../Pages/Inventory/DesignInventory.js"));
const LocationInventory = lazyWithRetry(() => import("../Pages/Inventory/LocationInventory.js"));
const ProductionPipeline = lazyWithRetry(() => import("../Pages/Inventory/ProductionPipeline.js"));
const StagePipeline = lazyWithRetry(() => import("../Pages/Inventory/StagePipeline.js"));
const VendorStock = lazyWithRetry(() => import("../Pages/Inventory/VendorStock.js"));
const BulkPrintInwardRegister = lazyWithRetry(() => import("../Pages/InwardRegister/BulkPrintInwardRegister.js"));
const InputInwardRegister = lazyWithRetry(() => import("../Pages/InwardRegister/InputInwardRegister.js"));
const InputInwardRegisterFromOutward = lazyWithRetry(() => import("../Pages/InwardRegister/InputInwardRegisterFromOutward.js"));
const InwardRegisterDetail = lazyWithRetry(() => import("../Pages/InwardRegister/InwardRegisterDetail.js"));
const InwardRegisters = lazyWithRetry(() => import("../Pages/InwardRegister/InwardRegisters.js"));
const InwardReport = lazyWithRetry(() => import("../Pages/InwardRegister/InwardReport.js"));
const PrintInwardRegister = lazyWithRetry(() => import("../Pages/InwardRegister/PrintInwardRegister.js"));
const UpdateInwardRegister = lazyWithRetry(() => import("../Pages/InwardRegister/UpdateInwardRegister.js"));
const InputJournalVoucher = lazyWithRetry(() => import("../Pages/JournalVoucher/InputJournalVoucher.js"));
const JournalVoucherDetails = lazyWithRetry(() => import("../Pages/JournalVoucher/JournalVoucherDetails.js"));
const JournalVoucherList = lazyWithRetry(() => import("../Pages/JournalVoucher/JournalVoucherList.js"));
const PrintJournalVoucher = lazyWithRetry(() => import("../Pages/JournalVoucher/PrintJournalVoucher.js"));
const LedgerAccounts = lazyWithRetry(() => import("../Pages/LedgerAccounts/LedgerAccounts.js"));
const DetailsLocation = lazyWithRetry(() => import("../Pages/Location/DetailsLocation.js"));
const InputLocation = lazyWithRetry(() => import("../Pages/Location/InputLocation.js"));
const Location = lazyWithRetry(() => import("../Pages/Location/Location.js"));
const UpdateLocation = lazyWithRetry(() => import("../Pages/Location/UpdateLocation.js"));
const Login = lazyWithRetry(() => import("../Pages/Login/Login.js"));
const ColumnLayoutEditor = lazyWithRetry(() => import("../Pages/LoomShade/ColumnLayoutEditor.js"));
const InputLoomShade = lazyWithRetry(() => import("../Pages/LoomShade/InputLoomShade.js"));
const LoomShade = lazyWithRetry(() => import("../Pages/LoomShade/LoomShade.js"));
const UpdateLoomShade = lazyWithRetry(() => import("../Pages/LoomShade/UpdateLoomShade.js"));
const MCSImport = lazyWithRetry(() => import("../Pages/MCSImport/MCSImport.js"));
const BulkLoomShade = lazyWithRetry(() => import("../Pages/Machine/BulkLoomShade.js"));
const InputMachine = lazyWithRetry(() => import("../Pages/Machine/InputMachine.js"));
const Machine = lazyWithRetry(() => import("../Pages/Machine/Machine.js"));
const MachineDetails = lazyWithRetry(() => import("../Pages/Machine/MachineDetails.js"));
const UpdateMachine = lazyWithRetry(() => import("../Pages/Machine/UpdateMachine.js"));
const BulkUpdateMatchings = lazyWithRetry(() => import("../Pages/Matching/BulkUpdateMatchings.js"));
const DesignMatching = lazyWithRetry(() => import("../Pages/Matching/DesignMatching.js"));
const InputMatching = lazyWithRetry(() => import("../Pages/Matching/InputMatching.js"));
const InputMatchingTable = lazyWithRetry(() => import("../Pages/Matching/InputMatchingTable.js"));
const MatchingApprovals = lazyWithRetry(() => import("../Pages/Matching/MatchingApprovals.js"));
const MatchingTable = lazyWithRetry(() => import("../Pages/Matching/MatchingTable.js"));
const SingleMatching = lazyWithRetry(() => import("../Pages/Matching/SingleMatching.js"));
const UpdateMatching = lazyWithRetry(() => import("../Pages/Matching/UpdateMatching.js"));
const InputMatchingCode = lazyWithRetry(() => import("../Pages/Matchingcodemap/InputMatchingCode.js"));
const MatchingCode = lazyWithRetry(() => import("../Pages/Matchingcodemap/MatchingCode.js"));
const UpdateMatchingCode = lazyWithRetry(() => import("../Pages/Matchingcodemap/UpdateMatchingCode.js"));
const NotFound = lazyWithRetry(() => import("../Pages/NotFound/NotFound.js"));
const InputOperator = lazyWithRetry(() => import("../Pages/Operator/InputOperator.js"));
const Operator = lazyWithRetry(() => import("../Pages/Operator/Operator.js"));
const UpdateOperator = lazyWithRetry(() => import("../Pages/Operator/UpdateOperator.js"));
const DownstreamFlow = lazyWithRetry(() => import("../Pages/Orderbook/DownstreamFlow.js"));
const InputOrderbook = lazyWithRetry(() => import("../Pages/Orderbook/InputOrderbook.js"));
const OrderbookDetails = lazyWithRetry(() => import("../Pages/Orderbook/OrderbookDetails.js"));
const Orderbooks = lazyWithRetry(() => import("../Pages/Orderbook/Orderbooks.js"));
const UpdateOrderbook = lazyWithRetry(() => import("../Pages/Orderbook/UpdateOrderbook.js"));
const InputOutwardChallan = lazyWithRetry(() => import("../Pages/OutwardChallan/InputOutwardChallan.js"));
const OutwardChallanDetail = lazyWithRetry(() => import("../Pages/OutwardChallan/OutwardChallanDetail.js"));
const OutwardChallans = lazyWithRetry(() => import("../Pages/OutwardChallan/OutwardChallans.js"));
const PrintOutwardChallan = lazyWithRetry(() => import("../Pages/OutwardChallan/PrintOutwardChallan.js"));
const UpdateOutwardChallan = lazyWithRetry(() => import("../Pages/OutwardChallan/UpdateOutwardChallan.js"));
const BulkEwayJobWork = lazyWithRetry(() => import("../Pages/OutwardRegister/BulkEwayJobWork.js"));
const BulkPrintOutwardRegister = lazyWithRetry(() => import("../Pages/OutwardRegister/BulkPrintOutwardRegister.js"));
const DeliveryReport = lazyWithRetry(() => import("../Pages/OutwardRegister/DeliveryReport.js"));
const EditOutwardRemarksModal = lazyWithRetry(() => import("../Pages/OutwardRegister/EditOutwardRemarksModal.js"));
const InputOutwardRegister = lazyWithRetry(() => import("../Pages/OutwardRegister/InputOutwardRegister.js"));
const InputOutwardRegisterFromPO = lazyWithRetry(() => import("../Pages/OutwardRegister/InputOutwardRegisterFromPO.js"));
const InputOutwardRegisterFromRegister = lazyWithRetry(() => import("../Pages/OutwardRegister/InputOutwardRegisterFromRegister.js"));
const InputOutwardRegisterMultiPO = lazyWithRetry(() => import("../Pages/OutwardRegister/InputOutwardRegisterMultiPO.js"));
const OutwardRegisterDeliveries = lazyWithRetry(() => import("../Pages/OutwardRegister/OutwardRegisterDeliveries.js"));
const OutwardRegisterDetail = lazyWithRetry(() => import("../Pages/OutwardRegister/OutwardRegisterDetail.js"));
const OutwardRegisters = lazyWithRetry(() => import("../Pages/OutwardRegister/OutwardRegisters.js"));
const PrintOutwardRegister = lazyWithRetry(() => import("../Pages/OutwardRegister/PrintOutwardRegister.js"));
const UpdateOutwardRegister = lazyWithRetry(() => import("../Pages/OutwardRegister/UpdateOutwardRegister.js"));
const OutwardWorkTypes = lazyWithRetry(() => import("../Pages/OutwardWorkType/OutwardWorkTypes.js"));
const BulkPartyContacts = lazyWithRetry(() => import("../Pages/Party/BulkPartyContacts.js"));
const InputParty = lazyWithRetry(() => import("../Pages/Party/InputParty.js"));
const Party = lazyWithRetry(() => import("../Pages/Party/Party.js"));
const PartyDetail = lazyWithRetry(() => import("../Pages/Party/PartyDetail.js"));
const UpdateParty = lazyWithRetry(() => import("../Pages/Party/UpdateParty.js"));
const InputPaymentVoucher = lazyWithRetry(() => import("../Pages/PaymentVoucher/InputPaymentVoucher.js"));
const PaymentVoucherDetail = lazyWithRetry(() => import("../Pages/PaymentVoucher/PaymentVoucherDetail.js"));
const PaymentVoucherList = lazyWithRetry(() => import("../Pages/PaymentVoucher/PaymentVoucherList.js"));
const PrintPaymentVoucher = lazyWithRetry(() => import("../Pages/PaymentVoucher/PrintPaymentVoucher.js"));
const ReconcilePaymentVoucher = lazyWithRetry(() => import("../Pages/PaymentVoucher/ReconcilePaymentVoucher.js"));
const SuspendedVouchers = lazyWithRetry(() => import("../Pages/PaymentVoucher/SuspendedVouchers.js"));
const UpdatePaymentVoucher = lazyWithRetry(() => import("../Pages/PaymentVoucher/UpdatePaymentVoucher.js"));
const BillAllocationGrid = lazyWithRetry(() => import("../Pages/PaymentVoucher/parts/BillAllocationGrid.jsx"));
const NoteApplyGrid = lazyWithRetry(() => import("../Pages/PaymentVoucher/parts/NoteApplyGrid.jsx"));
const AddPendingParty = lazyWithRetry(() => import("../Pages/PendingParty/AddPendingParty.js"));
const PendingParty = lazyWithRetry(() => import("../Pages/PendingParty/PendingParty.js"));
const InputPhotoshoot = lazyWithRetry(() => import("../Pages/Photoshoot/InputPhotoshoot.js"));
const Photoshoot = lazyWithRetry(() => import("../Pages/Photoshoot/Photoshoot.js"));
const PhotoshootEditor = lazyWithRetry(() => import("../Pages/Photoshoot/PhotoshootEditor.js"));
const OrderPhotoshoot = lazyWithRetry(() => import("../Pages/PhotoshootOrder/OrderPhotoshoot.js"));
const InputProcessingRecipe = lazyWithRetry(() => import("../Pages/ProcessingRecipe/InputProcessingRecipe.js"));
const ProcessingRecipeDetail = lazyWithRetry(() => import("../Pages/ProcessingRecipe/ProcessingRecipeDetail.js"));
const ProcessingRecipes = lazyWithRetry(() => import("../Pages/ProcessingRecipe/ProcessingRecipes.js"));
const UpdateProcessingRecipe = lazyWithRetry(() => import("../Pages/ProcessingRecipe/UpdateProcessingRecipe.js"));
const BulkCancelProductionOrder = lazyWithRetry(() => import("../Pages/ProductionOrder/BulkCancelProductionOrder.js"));
const BulkCancelProductionOrderHistory = lazyWithRetry(() => import("../Pages/ProductionOrder/BulkCancelProductionOrderHistory.js"));
const BulkPrintProductionOrder = lazyWithRetry(() => import("../Pages/ProductionOrder/BulkPrintProductionOrder.js"));
const CloseProductionOrder = lazyWithRetry(() => import("../Pages/ProductionOrder/CloseProductionOrder.js"));
const CompletedProductionOrders = lazyWithRetry(() => import("../Pages/ProductionOrder/CompletedProductionOrders.js"));
const GradeProductionOrder = lazyWithRetry(() => import("../Pages/ProductionOrder/GradeProductionOrder.js"));
const InputProductionOrder = lazyWithRetry(() => import("../Pages/ProductionOrder/InputProductionOrder.js"));
const PrintProductionOrder = lazyWithRetry(() => import("../Pages/ProductionOrder/PrintProductionOrder.js"));
const PrintUngradedGradingSheet = lazyWithRetry(() => import("../Pages/ProductionOrder/PrintUngradedGradingSheet.js"));
const ProductionCompletedForm = lazyWithRetry(() => import("../Pages/ProductionOrder/ProductionCompletedForm.js"));
const ProductionOrderDetail = lazyWithRetry(() => import("../Pages/ProductionOrder/ProductionOrderDetail.js"));
const ProductionOrders = lazyWithRetry(() => import("../Pages/ProductionOrder/ProductionOrders.js"));
const UngradedInventory = lazyWithRetry(() => import("../Pages/ProductionOrder/UngradedInventory.js"));
const UpdateCloseProductionOrder = lazyWithRetry(() => import("../Pages/ProductionOrder/UpdateCloseProductionOrder.js"));
const UpdateProductionOrder = lazyWithRetry(() => import("../Pages/ProductionOrder/UpdateProductionOrder.js"));
const BulkAddMachineProgram = lazyWithRetry(() => import("../Pages/Program/BulkAddMachineProgram.js"));
const BulkCloseMachineProgram = lazyWithRetry(() => import("../Pages/Program/BulkCloseMachineProgram.js"));
const BulkCloseMachineProgramHistory = lazyWithRetry(() => import("../Pages/Program/BulkCloseMachineProgramHistory.js"));
const CloseMachineProgram = lazyWithRetry(() => import("../Pages/Program/CloseMachineProgram.js"));
const ClothRollCompletion = lazyWithRetry(() => import("../Pages/Program/ClothRollCompletion.js"));
const ClothRollCompletionList = lazyWithRetry(() => import("../Pages/Program/ClothRollCompletionList.js"));
const DetailMachineProgramReport = lazyWithRetry(() => import("../Pages/Program/DetailMachineProgramReport.js"));
const InputMachineProgram = lazyWithRetry(() => import("../Pages/Program/InputMachineProgram.js"));
const InputMachineProgramOrderDirect = lazyWithRetry(() => import("../Pages/Program/InputMachineProgramOrderDirect.js"));
const MachineProgram = lazyWithRetry(() => import("../Pages/Program/MachineProgram.js"));
const MachineProgramOrderEditor = lazyWithRetry(() => import("../Pages/Program/MachineProgramOrderEditor.js"));
const MachineProgramReport = lazyWithRetry(() => import("../Pages/Program/MachineProgramReport.js"));
const MachineProgramRunSelection = lazyWithRetry(() => import("../Pages/Program/MachineProgramRunSelection.js"));
const MachineProgramRunSelectionList = lazyWithRetry(() => import("../Pages/Program/MachineProgramRunSelectionList.js"));
const MachineProgramRunSelectionPrint = lazyWithRetry(() => import("../Pages/Program/MachineProgramRunSelectionPrint.js"));
const PrintMachineProgram = lazyWithRetry(() => import("../Pages/Program/PrintMachineProgram.js"));
const PrintPOMachineProgram = lazyWithRetry(() => import("../Pages/Program/PrintPOMachineProgram.js"));
const PrintSingleMachineProgram = lazyWithRetry(() => import("../Pages/Program/PrintSingleMachineProgram.js"));
const PrintSummaryMachineProgram = lazyWithRetry(() => import("../Pages/Program/PrintSummaryMachineProgram.js"));
const TransferMachineProgram = lazyWithRetry(() => import("../Pages/Program/TransferMachineProgram.js"));
const TransferMultipleMachineProgram = lazyWithRetry(() => import("../Pages/Program/TransferMultipleMachineProgram.js"));
const CombinePurchaseBill = lazyWithRetry(() => import("../Pages/PurchaseBill/CombinePurchaseBill.js"));
const InputPurchaseBill = lazyWithRetry(() => import("../Pages/PurchaseBill/InputPurchaseBill.js"));
const PrintPurchaseBill = lazyWithRetry(() => import("../Pages/PurchaseBill/PrintPurchaseBill.js"));
const PurchaseBill = lazyWithRetry(() => import("../Pages/PurchaseBill/PurchaseBill.js"));
const PurchaseBillDetail = lazyWithRetry(() => import("../Pages/PurchaseBill/PurchaseBillDetail.js"));
const PurchaseBillFromChallans = lazyWithRetry(() => import("../Pages/PurchaseBill/PurchaseBillFromChallans.jsx"));
const UpdatePurchaseBill = lazyWithRetry(() => import("../Pages/PurchaseBill/UpdatePurchaseBill.js"));
const VerifyPurchaseBillDraft = lazyWithRetry(() => import("../Pages/PurchaseBill/VerifyPurchaseBillDraft.js"));
const InputPurchaseChallan = lazyWithRetry(() => import("../Pages/PurchaseChallan/InputPurchaseChallan.js"));
const PrintPurchaseChallan = lazyWithRetry(() => import("../Pages/PurchaseChallan/PrintPurchaseChallan.js"));
const PurchaseChallan = lazyWithRetry(() => import("../Pages/PurchaseChallan/PurchaseChallan.js"));
const PurchaseChallanDetails = lazyWithRetry(() => import("../Pages/PurchaseChallan/PurchaseChallanDetails.js"));
const UpdatePurchaseChallan = lazyWithRetry(() => import("../Pages/PurchaseChallan/UpdatePurchaseChallan.js"));
const DetailPetaOrder = lazyWithRetry(() => import("../Pages/PurchaseOrder/DetailPetaOrder.js"));
const DetailPurchaseOrder = lazyWithRetry(() => import("../Pages/PurchaseOrder/DetailPurchaseOrder.js"));
const InputPetaOrder = lazyWithRetry(() => import("../Pages/PurchaseOrder/InputPetaOrder.js"));
const InputPurchaseOrder = lazyWithRetry(() => import("../Pages/PurchaseOrder/InputPurchaseOrder.js"));
const PetaOrder = lazyWithRetry(() => import("../Pages/PurchaseOrder/PetaOrder.js"));
const PrintPurchaseOrder = lazyWithRetry(() => import("../Pages/PurchaseOrder/PrintPurchaseOrder.js"));
const PurchaseOrder = lazyWithRetry(() => import("../Pages/PurchaseOrder/PurchaseOrder.js"));
const UpdatePetaOrder = lazyWithRetry(() => import("../Pages/PurchaseOrder/UpdatePetaOrder.js"));
const UpdatePurchaseOrder = lazyWithRetry(() => import("../Pages/PurchaseOrder/UpdatePurchaseOrder.js"));
const InputQRAudit = lazyWithRetry(() => import("../Pages/QRAudit/InputQRAudit.js"));
const InputQRLocationAudit = lazyWithRetry(() => import("../Pages/QRAudit/InputQRLocationAudit.js"));
const QRAuditDetail = lazyWithRetry(() => import("../Pages/QRAudit/QRAuditDetail.js"));
const QRAudits = lazyWithRetry(() => import("../Pages/QRAudit/QRAudits.js"));
const BulkPrintQRInternalTransfer = lazyWithRetry(() => import("../Pages/QRInternalTransfer/BulkPrintQRInternalTransfer.js"));
const InputQRInternalTransfer = lazyWithRetry(() => import("../Pages/QRInternalTransfer/InputQRInternalTransfer.js"));
const PrintQRInternalTransfer = lazyWithRetry(() => import("../Pages/QRInternalTransfer/PrintQRInternalTransfer.js"));
const PrintQRInternalTransferLabels = lazyWithRetry(() => import("../Pages/QRInternalTransfer/PrintQRInternalTransferLabels.js"));
const QRInternalTransferDetail = lazyWithRetry(() => import("../Pages/QRInternalTransfer/QRInternalTransferDetail.js"));
const QRInternalTransfers = lazyWithRetry(() => import("../Pages/QRInternalTransfer/QRInternalTransfers.js"));
const ReceiveQRInternalTransfer = lazyWithRetry(() => import("../Pages/QRInternalTransfer/ReceiveQRInternalTransfer.js"));
const UpdateQRInternalTransfer = lazyWithRetry(() => import("../Pages/QRInternalTransfer/UpdateQRInternalTransfer.js"));
const BulkPrintQRInwardRegister = lazyWithRetry(() => import("../Pages/QRInwardRegister/BulkPrintQRInwardRegister.js"));
const InputQRInwardRegister = lazyWithRetry(() => import("../Pages/QRInwardRegister/InputQRInwardRegister.js"));
const PrintQRInwardRegister = lazyWithRetry(() => import("../Pages/QRInwardRegister/PrintQRInwardRegister.js"));
const PrintQRInwardRegisterLabels = lazyWithRetry(() => import("../Pages/QRInwardRegister/PrintQRInwardRegisterLabels.js"));
const QRInwardRegisterDetail = lazyWithRetry(() => import("../Pages/QRInwardRegister/QRInwardRegisterDetail.js"));
const QRInwardRegisters = lazyWithRetry(() => import("../Pages/QRInwardRegister/QRInwardRegisters.js"));
const QRInwardReport = lazyWithRetry(() => import("../Pages/QRInwardRegister/QRInwardReport.js"));
const UpdateQRInwardRegister = lazyWithRetry(() => import("../Pages/QRInwardRegister/UpdateQRInwardRegister.js"));
const InputQRMigration = lazyWithRetry(() => import("../Pages/QRMigration/InputQRMigration.js"));
const QRMigrationDetail = lazyWithRetry(() => import("../Pages/QRMigration/QRMigrationDetail.js"));
const QRMigrations = lazyWithRetry(() => import("../Pages/QRMigration/QRMigrations.js"));
const BulkPrintQROutwardRegister = lazyWithRetry(() => import("../Pages/QROutwardRegister/BulkPrintQROutwardRegister.js"));
const InputQROutwardRegister = lazyWithRetry(() => import("../Pages/QROutwardRegister/InputQROutwardRegister.js"));
const InputQROutwardRegisterFromRegister = lazyWithRetry(() => import("../Pages/QROutwardRegister/InputQROutwardRegisterFromRegister.js"));
const PrintQROutwardRegister = lazyWithRetry(() => import("../Pages/QROutwardRegister/PrintQROutwardRegister.js"));
const PrintQROutwardRegisterLabels = lazyWithRetry(() => import("../Pages/QROutwardRegister/PrintQROutwardRegisterLabels.js"));
const QRDeliveryReport = lazyWithRetry(() => import("../Pages/QROutwardRegister/QRDeliveryReport.js"));
const QROutwardRegisterDeliveries = lazyWithRetry(() => import("../Pages/QROutwardRegister/QROutwardRegisterDeliveries.js"));
const QROutwardRegisterDetail = lazyWithRetry(() => import("../Pages/QROutwardRegister/QROutwardRegisterDetail.js"));
const QROutwardRegisters = lazyWithRetry(() => import("../Pages/QROutwardRegister/QROutwardRegisters.js"));
const UpdateQROutwardRegister = lazyWithRetry(() => import("../Pages/QROutwardRegister/UpdateQROutwardRegister.js"));
const MarkVoided = lazyWithRetry(() => import("../Pages/QRScanTimer/MarkVoided.js"));
const ScanTimer = lazyWithRetry(() => import("../Pages/QRScanTimer/ScanTimer.js"));
const InputQRStockAdjustment = lazyWithRetry(() => import("../Pages/QRStockAdjustment/InputQRStockAdjustment.js"));
const QRStockAdjustmentDetail = lazyWithRetry(() => import("../Pages/QRStockAdjustment/QRStockAdjustmentDetail.js"));
const QRStockAdjustments = lazyWithRetry(() => import("../Pages/QRStockAdjustment/QRStockAdjustments.js"));
const InputQRStockDeduction = lazyWithRetry(() => import("../Pages/QRStockDeduction/InputQRStockDeduction.js"));
const QRStockDeductionDetail = lazyWithRetry(() => import("../Pages/QRStockDeduction/QRStockDeductionDetail.js"));
const QRStockDeductions = lazyWithRetry(() => import("../Pages/QRStockDeduction/QRStockDeductions.js"));
const ApprovedQuality = lazyWithRetry(() => import("../Pages/Quality/ApprovedQuality.js"));
const DetailsQuality = lazyWithRetry(() => import("../Pages/Quality/DetailsQuality.js"));
const InputQuality = lazyWithRetry(() => import("../Pages/Quality/InputQuality.js"));
const Quality = lazyWithRetry(() => import("../Pages/Quality/Quality.js"));
const UpdateQuality = lazyWithRetry(() => import("../Pages/Quality/UpdateQuality.js"));
const RackDetail = lazyWithRetry(() => import("../Pages/Rack/RackDetail.js"));
const Racks = lazyWithRetry(() => import("../Pages/Rack/Racks.js"));
const AgentCommission = lazyWithRetry(() => import("../Pages/Receivables/AgentCommission.js"));
const LateInterest = lazyWithRetry(() => import("../Pages/Receivables/LateInterest.js"));
const PaymentReminders = lazyWithRetry(() => import("../Pages/Receivables/PaymentReminders.js"));
const CatalogueStock = lazyWithRetry(() => import("../Pages/Replenishment/CatalogueStock.js"));
const Replenishment = lazyWithRetry(() => import("../Pages/Replenishment/Replenishment.js"));
const ReplenishmentRequestView = lazyWithRetry(() => import("../Pages/Replenishment/ReplenishmentRequestView.js"));
const ReplenishmentSettings = lazyWithRetry(() => import("../Pages/Replenishment/ReplenishmentSettings.js"));
const ShopStock = lazyWithRetry(() => import("../Pages/Replenishment/ShopStock.js"));
const InputRole = lazyWithRetry(() => import("../Pages/Role/InputRole.js"));
const Role = lazyWithRetry(() => import("../Pages/Role/Role.js"));
const RoleDetails = lazyWithRetry(() => import("../Pages/Role/RoleDetails.js"));
const UpdateRole = lazyWithRetry(() => import("../Pages/Role/UpdateRole.js"));
const BulkEwaySalesBill = lazyWithRetry(() => import("../Pages/SalesBill/BulkEwaySalesBill.js"));
const BulkPrintSalesBill = lazyWithRetry(() => import("../Pages/SalesBill/BulkPrintSalesBill.js"));
const InputSalesBill = lazyWithRetry(() => import("../Pages/SalesBill/InputSalesBill.js"));
const PrintSalesBill = lazyWithRetry(() => import("../Pages/SalesBill/PrintSalesBill.js"));
const SalesBill = lazyWithRetry(() => import("../Pages/SalesBill/SalesBill.js"));
const SalesBillDetail = lazyWithRetry(() => import("../Pages/SalesBill/SalesBillDetail.js"));
const TransportReceipts = lazyWithRetry(() => import("../Pages/SalesBill/TransportReceipts.js"));
const UpdateSalesBill = lazyWithRetry(() => import("../Pages/SalesBill/UpdateSalesBill.js"));
const BillDetailsCard = lazyWithRetry(() => import("../Pages/SalesBill/form/BillDetailsCard.js"));
const BillSummary = lazyWithRetry(() => import("../Pages/SalesBill/form/BillSummary.js"));
const LineItemsTable = lazyWithRetry(() => import("../Pages/SalesBill/form/LineItemsTable.js"));
const BulkPrintSalesChallan = lazyWithRetry(() => import("../Pages/SalesChallan/BulkPrintSalesChallan.js"));
const InputSalesChallan = lazyWithRetry(() => import("../Pages/SalesChallan/InputSalesChallan.js"));
const PrintSalesChallan = lazyWithRetry(() => import("../Pages/SalesChallan/PrintSalesChallan.js"));
const SalesChallan = lazyWithRetry(() => import("../Pages/SalesChallan/SalesChallan.js"));
const SalesChallanDetail = lazyWithRetry(() => import("../Pages/SalesChallan/SalesChallanDetail.js"));
const UpdateSalesChallan = lazyWithRetry(() => import("../Pages/SalesChallan/UpdateSalesChallan.js"));
const AmendSalesOrder = lazyWithRetry(() => import("../Pages/SalesOrder/AmendSalesOrder.js"));
const BulkPrintPendingSalesOrder = lazyWithRetry(() => import("../Pages/SalesOrder/BulkPrintPendingSalesOrder.js"));
const ClosedSalesOrders = lazyWithRetry(() => import("../Pages/SalesOrder/ClosedSalesOrders.js"));
const InputSalesOrder = lazyWithRetry(() => import("../Pages/SalesOrder/InputSalesOrder.js"));
const PendingDesignsByCatalogue = lazyWithRetry(() => import("../Pages/SalesOrder/PendingDesignsByCatalogue.js"));
const PendingDesignsByParty = lazyWithRetry(() => import("../Pages/SalesOrder/PendingDesignsByParty.js"));
const PendingSalesOrders = lazyWithRetry(() => import("../Pages/SalesOrder/PendingSalesOrders.js"));
const PickListByRack = lazyWithRetry(() => import("../Pages/SalesOrder/PickListByRack.js"));
const PrintPartyPendingSaree = lazyWithRetry(() => import("../Pages/SalesOrder/PrintPartyPendingSaree.js"));
const PrintPendingSaree = lazyWithRetry(() => import("../Pages/SalesOrder/PrintPendingSaree.js"));
const PrintSalesOrder = lazyWithRetry(() => import("../Pages/SalesOrder/PrintSalesOrder.js"));
const QuickColourToggle = lazyWithRetry(() => import("../Pages/SalesOrder/QuickColourToggle.js"));
const ReadyToDispatch = lazyWithRetry(() => import("../Pages/SalesOrder/ReadyToDispatch.js"));
const SalesOrder = lazyWithRetry(() => import("../Pages/SalesOrder/SalesOrder.js"));
const SalesOrderBulkActions = lazyWithRetry(() => import("../Pages/SalesOrder/SalesOrderBulkActions.js"));
const SalesOrderDesignTable = lazyWithRetry(() => import("../Pages/SalesOrder/SalesOrderDesignTable.js"));
const SalesOrderDetail = lazyWithRetry(() => import("../Pages/SalesOrder/SalesOrderDetail.js"));
const SalesOrderQrScan = lazyWithRetry(() => import("../Pages/SalesOrder/SalesOrderQrScan.js"));
const UpdateSalesOrder = lazyWithRetry(() => import("../Pages/SalesOrder/UpdateSalesOrder.js"));
const AgentPerformance = lazyWithRetry(() => import("../Pages/SalesReports/AgentPerformance.js"));
const CatalogueWiseSales = lazyWithRetry(() => import("../Pages/SalesReports/CatalogueWiseSales.js"));
const ChallanRegister = lazyWithRetry(() => import("../Pages/SalesReports/ChallanRegister.js"));
const ClothRollProductionReport = lazyWithRetry(() => import("../Pages/SalesReports/ClothRollProductionReport.js"));
const ClothRollProductionTrendChart = lazyWithRetry(() => import("../Pages/SalesReports/ClothRollProductionTrendChart.js"));
const DayWiseRollOpenedSection = lazyWithRetry(() => import("../Pages/SalesReports/DayWiseRollOpenedSection.js"));
const EndOfDaySummary = lazyWithRetry(() => import("../Pages/SalesReports/EndOfDaySummary.js"));
const FYSummary = lazyWithRetry(() => import("../Pages/SalesReports/FYSummary.js"));
const FirmWiseComparison = lazyWithRetry(() => import("../Pages/SalesReports/FirmWiseComparison.js"));
const GSTSummary = lazyWithRetry(() => import("../Pages/SalesReports/GSTSummary.js"));
const GoodsMovementReport = lazyWithRetry(() => import("../Pages/SalesReports/GoodsMovementReport.js"));
const OrderBook = lazyWithRetry(() => import("../Pages/SalesReports/OrderBook.js"));
const OutstandingReport = lazyWithRetry(() => import("../Pages/SalesReports/OutstandingReport.js"));
const PartyCatalogueMessage = lazyWithRetry(() => import("../Pages/SalesReports/PartyCatalogueMessage.js"));
const PartyLedger = lazyWithRetry(() => import("../Pages/SalesReports/PartyLedger.js"));
const PaymentCollection = lazyWithRetry(() => import("../Pages/SalesReports/PaymentCollection.js"));
const PeriodicSummary = lazyWithRetry(() => import("../Pages/SalesReports/PeriodicSummary.js"));
const ProductionOrderReport = lazyWithRetry(() => import("../Pages/SalesReports/ProductionOrderReport.js"));
const ProductionOutputReport = lazyWithRetry(() => import("../Pages/SalesReports/ProductionOutputReport.js"));
const ProductionReport = lazyWithRetry(() => import("../Pages/SalesReports/ProductionReport.js"));
const ReceivablesAging = lazyWithRetry(() => import("../Pages/SalesReports/ReceivablesAging.js"));
const SalesBillRegister = lazyWithRetry(() => import("../Pages/SalesReports/SalesBillRegister.js"));
const SalesmanPerformance = lazyWithRetry(() => import("../Pages/SalesReports/SalesmanPerformance.js"));
const SecondsReport = lazyWithRetry(() => import("../Pages/SalesReports/SecondsReport.js"));
const TodayProductionReport = lazyWithRetry(() => import("../Pages/SalesReports/TodayProductionReport.js"));
const AmendSalesReturn = lazyWithRetry(() => import("../Pages/SalesReturn/AmendSalesReturn.js"));
const BulkPrintSalesReturn = lazyWithRetry(() => import("../Pages/SalesReturn/BulkPrintSalesReturn.js"));
const ChargeGstSelect = lazyWithRetry(() => import("../Pages/SalesReturn/ChargeGstSelect.js"));
const DisputeResolutionModal = lazyWithRetry(() => import("../Pages/SalesReturn/DisputeResolutionModal.js"));
const InputSalesReturn = lazyWithRetry(() => import("../Pages/SalesReturn/InputSalesReturn.js"));
const PartyGrNotes = lazyWithRetry(() => import("../Pages/SalesReturn/PartyGrNotes.js"));
const PrintSalesReturn = lazyWithRetry(() => import("../Pages/SalesReturn/PrintSalesReturn.js"));
const PrintSalesReturnLabels = lazyWithRetry(() => import("../Pages/SalesReturn/PrintSalesReturnLabels.js"));
const SalesReturn = lazyWithRetry(() => import("../Pages/SalesReturn/SalesReturn.js"));
const SalesReturnApprovals = lazyWithRetry(() => import("../Pages/SalesReturn/SalesReturnApprovals.js"));
const SalesReturnDetail = lazyWithRetry(() => import("../Pages/SalesReturn/SalesReturnDetail.js"));
const UpdateSalesReturn = lazyWithRetry(() => import("../Pages/SalesReturn/UpdateSalesReturn.js"));
const AmendSalesSet = lazyWithRetry(() => import("../Pages/SalesSet/AmendSalesSet.js"));
const InputSalesSet = lazyWithRetry(() => import("../Pages/SalesSet/InputSalesSet.js"));
const SalesSetList = lazyWithRetry(() => import("../Pages/SalesSet/SalesSetList.js"));
const InputSalesman = lazyWithRetry(() => import("../Pages/Salesman/InputSalesman.js"));
const Salesman = lazyWithRetry(() => import("../Pages/Salesman/Salesman.js"));
const UpdateSalesman = lazyWithRetry(() => import("../Pages/Salesman/UpdateSalesman.js"));
const DetailsSample = lazyWithRetry(() => import("../Pages/Sample/DetailsSample.js"));
const InputSample = lazyWithRetry(() => import("../Pages/Sample/InputSample.js"));
const PrintSample = lazyWithRetry(() => import("../Pages/Sample/PrintSample.js"));
const Sample = lazyWithRetry(() => import("../Pages/Sample/Sample.js"));
const UpdateSample = lazyWithRetry(() => import("../Pages/Sample/UpdateSample.js"));
const InputSareeCategory = lazyWithRetry(() => import("../Pages/SareeCategory/InputSareeCategory.js"));
const SareeCategory = lazyWithRetry(() => import("../Pages/SareeCategory/SareeCategory.js"));
const UpdateSareeCategory = lazyWithRetry(() => import("../Pages/SareeCategory/UpdateSareeCategory.js"));
const AddSecondsBatch = lazyWithRetry(() => import("../Pages/SecondsBatch/AddSecondsBatch.js"));
const PrintSecondsBatch = lazyWithRetry(() => import("../Pages/SecondsBatch/PrintSecondsBatch.js"));
const SecondsBatchDetails = lazyWithRetry(() => import("../Pages/SecondsBatch/SecondsBatchDetails.js"));
const SecondsBatchList = lazyWithRetry(() => import("../Pages/SecondsBatch/SecondsBatchList.js"));
const SessionExpired = lazyWithRetry(() => import("../Pages/SessionExpired/SessionExpired.js"));
const AmendSetTemplate = lazyWithRetry(() => import("../Pages/SetTemplate/AmendSetTemplate.js"));
const DetailsSetTemplate = lazyWithRetry(() => import("../Pages/SetTemplate/DetailsSetTemplate.js"));
const InputSetTemplate = lazyWithRetry(() => import("../Pages/SetTemplate/InputSetTemplate.js"));
const SetTemplateList = lazyWithRetry(() => import("../Pages/SetTemplate/SetTemplateList.js"));
const SopRuns = lazyWithRetry(() => import("../Pages/Sop/SopRuns.js"));
const SopTemplateEditor = lazyWithRetry(() => import("../Pages/Sop/SopTemplateEditor.js"));
const SopTemplates = lazyWithRetry(() => import("../Pages/Sop/SopTemplates.js"));
const InputStitchTemplate = lazyWithRetry(() => import("../Pages/StitchTemplate/InputStitchTemplate.js"));
const StitchTemplateDetail = lazyWithRetry(() => import("../Pages/StitchTemplate/StitchTemplateDetail.js"));
const StitchTemplates = lazyWithRetry(() => import("../Pages/StitchTemplate/StitchTemplates.js"));
const UpdateStitchTemplate = lazyWithRetry(() => import("../Pages/StitchTemplate/UpdateStitchTemplate.js"));
const CatalogueMatchingBlock = lazyWithRetry(() => import("../Pages/StitchingInward/CatalogueMatchingBlock.js"));
const ComponentConsumptionSummary = lazyWithRetry(() => import("../Pages/StitchingInward/ComponentConsumptionSummary.js"));
const InputStitchingInward = lazyWithRetry(() => import("../Pages/StitchingInward/InputStitchingInward.js"));
const StitchingInwardDetail = lazyWithRetry(() => import("../Pages/StitchingInward/StitchingInwardDetail.js"));
const StitchingInwardList = lazyWithRetry(() => import("../Pages/StitchingInward/StitchingInwardList.js"));
const UpdateStitchingInward = lazyWithRetry(() => import("../Pages/StitchingInward/UpdateStitchingInward.js"));
const AddStockAdjustment = lazyWithRetry(() => import("../Pages/StockAdjustment/AddStockAdjustment.js"));
const DeductStockAdjustment = lazyWithRetry(() => import("../Pages/StockAdjustment/DeductStockAdjustment.js"));
const InputStockAdjustment = lazyWithRetry(() => import("../Pages/StockAdjustment/InputStockAdjustment.js"));
const StockAdjustmentDetail = lazyWithRetry(() => import("../Pages/StockAdjustment/StockAdjustmentDetail.js"));
const StockAdjustments = lazyWithRetry(() => import("../Pages/StockAdjustment/StockAdjustments.js"));
const UpdateStockAdjustment = lazyWithRetry(() => import("../Pages/StockAdjustment/UpdateStockAdjustment.js"));
const ZeroStockAtLocationModal = lazyWithRetry(() => import("../Pages/StockAdjustment/ZeroStockAtLocationModal.js"));
const RegradeStock = lazyWithRetry(() => import("../Pages/StockRegrade/RegradeStock.js"));
const StockRegradeDetail = lazyWithRetry(() => import("../Pages/StockRegrade/StockRegradeDetail.js"));
const StockRegradeList = lazyWithRetry(() => import("../Pages/StockRegrade/StockRegradeList.js"));
const InputTransport = lazyWithRetry(() => import("../Pages/Transport/InputTransport.js"));
const Transport = lazyWithRetry(() => import("../Pages/Transport/Transport.js"));
const UpdateTransport = lazyWithRetry(() => import("../Pages/Transport/UpdateTransport.js"));
const BulkRegradeUnitQR = lazyWithRetry(() => import("../Pages/UnitQR/BulkRegradeUnitQR.js"));
const CorrectUnitQR = lazyWithRetry(() => import("../Pages/UnitQR/CorrectUnitQR.js"));
const GenerateQR = lazyWithRetry(() => import("../Pages/UnitQR/GenerateQR.js"));
const GenerateQRFromRegister = lazyWithRetry(() => import("../Pages/UnitQR/GenerateQRFromRegister.js"));
const GeneratedQRDetail = lazyWithRetry(() => import("../Pages/UnitQR/GeneratedQRDetail.js"));
const GeneratedQRList = lazyWithRetry(() => import("../Pages/UnitQR/GeneratedQRList.js"));
const PrintGeneratedQR = lazyWithRetry(() => import("../Pages/UnitQR/PrintGeneratedQR.js"));
const PrintUnitQR = lazyWithRetry(() => import("../Pages/UnitQR/PrintUnitQR.js"));
const PrintUnitQRLabels = lazyWithRetry(() => import("../Pages/UnitQR/PrintUnitQRLabels.js"));
const RegradeUnitQR = lazyWithRetry(() => import("../Pages/UnitQR/RegradeUnitQR.js"));
const ScanQR = lazyWithRetry(() => import("../Pages/UnitQR/ScanQR.js"));
const UnitQRList = lazyWithRetry(() => import("../Pages/UnitQR/UnitQRList.js"));
const UnitQRTag = lazyWithRetry(() => import("../Pages/UnitQR/UnitQRTag.js"));
const InputUser = lazyWithRetry(() => import("../Pages/User/InputUser.js"));
const UpdateUser = lazyWithRetry(() => import("../Pages/User/UpdateUser.js"));
const User = lazyWithRetry(() => import("../Pages/User/User.js"));
const UserPermissions = lazyWithRetry(() => import("../Pages/User/UserPermissions.js"));
const InputValueAddition = lazyWithRetry(() => import("../Pages/ValueAddition/InputValueAddition.js"));
const UpdateValueAddition = lazyWithRetry(() => import("../Pages/ValueAddition/UpdateValueAddition.js"));
const ValueAddition = lazyWithRetry(() => import("../Pages/ValueAddition/ValueAddition.js"));
const InputVendorProcessing = lazyWithRetry(() => import("../Pages/VendorProcessing/InputVendorProcessing.js"));
const UpdateVendorProcessing = lazyWithRetry(() => import("../Pages/VendorProcessing/UpdateVendorProcessing.js"));
const VendorProcessingDetail = lazyWithRetry(() => import("../Pages/VendorProcessing/VendorProcessingDetail.js"));
const VendorProcessingList = lazyWithRetry(() => import("../Pages/VendorProcessing/VendorProcessingList.js"));
const VendorRegister = lazyWithRetry(() => import("../Pages/VendorRegister/VendorRegister.js"));
const AddVendorStockAdjustment = lazyWithRetry(() => import("../Pages/VendorStockAdjustment/AddVendorStockAdjustment.js"));
const DeductVendorStockAdjustment = lazyWithRetry(() => import("../Pages/VendorStockAdjustment/DeductVendorStockAdjustment.js"));
const InputVendorStockAdjustment = lazyWithRetry(() => import("../Pages/VendorStockAdjustment/InputVendorStockAdjustment.js"));
const UpdateVendorStockAdjustment = lazyWithRetry(() => import("../Pages/VendorStockAdjustment/UpdateVendorStockAdjustment.js"));
const VendorStockAdjustmentDetail = lazyWithRetry(() => import("../Pages/VendorStockAdjustment/VendorStockAdjustmentDetail.js"));
const VendorStockAdjustments = lazyWithRetry(() => import("../Pages/VendorStockAdjustment/VendorStockAdjustments.js"));
const ZeroStockByCatalogueModal = lazyWithRetry(() => import("../Pages/VendorStockAdjustment/ZeroStockByCatalogueModal.js"));
const ZeroStockByDateModal = lazyWithRetry(() => import("../Pages/VendorStockAdjustment/ZeroStockByDateModal.js"));
const InputWarpDesignColour = lazyWithRetry(() => import("../Pages/Warp Design Colour/InputWarpDesignColour.js"));
const UpdateWarpDesignColour = lazyWithRetry(() => import("../Pages/Warp Design Colour/UpdateWarpDesignColour.js"));
const WarpDesignColour = lazyWithRetry(() => import("../Pages/Warp Design Colour/WarpDesignColour.js"));
const InputWarpPattern = lazyWithRetry(() => import("../Pages/WarpPattern/InputWarpPattern.js"));
const UpdateWarpPattern = lazyWithRetry(() => import("../Pages/WarpPattern/UpdateWarpPattern.js"));
const WarpPattern = lazyWithRetry(() => import("../Pages/WarpPattern/WarpPattern.js"));
const WarpPatternForm = lazyWithRetry(() => import("../Pages/WarpPattern/WarpPatternForm.js"));
const DetailsWarpbeam = lazyWithRetry(() => import("../Pages/Warpbeam/DetailsWarpbeam.js"));
const InputWarpbeam = lazyWithRetry(() => import("../Pages/Warpbeam/InputWarpbeam.js"));
const PrintWarpbeam = lazyWithRetry(() => import("../Pages/Warpbeam/PrintWarpbeam.js"));
const UpdateWarpbeam = lazyWithRetry(() => import("../Pages/Warpbeam/UpdateWarpbeam.js"));
const Warpbeam = lazyWithRetry(() => import("../Pages/Warpbeam/Warpbeam.js"));
const WarpbeamForm = lazyWithRetry(() => import("../Pages/Warpbeam/WarpbeamForm.js"));
const AttachPreview = lazyWithRetry(() => import("../Pages/WhatsAppInbox/AttachPreview.js"));
const ChatList = lazyWithRetry(() => import("../Pages/WhatsAppInbox/ChatList.js"));
const ChatThread = lazyWithRetry(() => import("../Pages/WhatsAppInbox/ChatThread.js"));
const Composer = lazyWithRetry(() => import("../Pages/WhatsAppInbox/Composer.js"));
const ContactPanel = lazyWithRetry(() => import("../Pages/WhatsAppInbox/ContactPanel.js"));
const MediaViewer = lazyWithRetry(() => import("../Pages/WhatsAppInbox/MediaViewer.js"));
const MessageBubble = lazyWithRetry(() => import("../Pages/WhatsAppInbox/MessageBubble.js"));
const MessageInfo = lazyWithRetry(() => import("../Pages/WhatsAppInbox/MessageInfo.js"));
const QuickRepliesManager = lazyWithRetry(() => import("../Pages/WhatsAppInbox/QuickRepliesManager.js"));
const ShortcutsHelp = lazyWithRetry(() => import("../Pages/WhatsAppInbox/ShortcutsHelp.js"));
const WhatsAppInbox = lazyWithRetry(() => import("../Pages/WhatsAppInbox/WhatsAppInbox.js"));
const SendInvoices = lazyWithRetry(() => import("../Pages/WhatsAppInvoices/SendInvoices.js"));
const SendTransportReceipts = lazyWithRetry(() => import("../Pages/WhatsAppInvoices/SendTransportReceipts.js"));
const BulkAddCartoon = lazyWithRetry(() => import("../Pages/YarnInventory/BulkAddCartoon.js"));
const BulkConsumeCartoon = lazyWithRetry(() => import("../Pages/YarnInventory/BulkConsumeCartoon.js"));
const BulkDeleteCartoon = lazyWithRetry(() => import("../Pages/YarnInventory/BulkDeleteCartoon.js"));
const CartoonAuditTrail = lazyWithRetry(() => import("../Pages/YarnInventory/CartoonAuditTrail.js"));
const CartoonList = lazyWithRetry(() => import("../Pages/YarnInventory/CartoonList.js"));
const CartoonQualityShadeAudit = lazyWithRetry(() => import("../Pages/YarnInventory/CartoonQualityShadeAudit.js"));
const InputCartoonLocationAudit = lazyWithRetry(() => import("../Pages/YarnInventory/InputCartoonLocationAudit.js"));
const InputSupplierReturn = lazyWithRetry(() => import("../Pages/YarnInventory/InputSupplierReturn.js"));
const InputYarnCartonAdjustment = lazyWithRetry(() => import("../Pages/YarnInventory/InputYarnCartonAdjustment.js"));
const InputYarnCartonConsumption = lazyWithRetry(() => import("../Pages/YarnInventory/InputYarnCartonConsumption.js"));
const InputYarnCartonConsumptionSheet = lazyWithRetry(() => import("../Pages/YarnInventory/InputYarnCartonConsumptionSheet.js"));
const InputYarnConsumption = lazyWithRetry(() => import("../Pages/YarnInventory/InputYarnConsumption.js"));
const InputYarnConsumptionByCartoon = lazyWithRetry(() => import("../Pages/YarnInventory/InputYarnConsumptionByCartoon.js"));
const InputYarnSale = lazyWithRetry(() => import("../Pages/YarnInventory/InputYarnSale.js"));
const InputYarnTransfer = lazyWithRetry(() => import("../Pages/YarnInventory/InputYarnTransfer.js"));
const MonthlyPurchaseReport = lazyWithRetry(() => import("../Pages/YarnInventory/MonthlyPurchaseReport.js"));
const PrintCartoonLabels = lazyWithRetry(() => import("../Pages/YarnInventory/PrintCartoonLabels.js"));
const PrintYarnAdjustment = lazyWithRetry(() => import("../Pages/YarnInventory/PrintYarnAdjustment.js"));
const PrintYarnCartonDaySummary = lazyWithRetry(() => import("../Pages/YarnInventory/PrintYarnCartonDaySummary.js"));
const PrintYarnCartonStock = lazyWithRetry(() => import("../Pages/YarnInventory/PrintYarnCartonStock.js"));
const RegisterYarnReceipt = lazyWithRetry(() => import("../Pages/YarnInventory/RegisterYarnReceipt.js"));
const RunRateProblemChart = lazyWithRetry(() => import("../Pages/YarnInventory/RunRateProblemChart.js"));
const RunRateProjectionChart = lazyWithRetry(() => import("../Pages/YarnInventory/RunRateProjectionChart.js"));
const ScanCartoon = lazyWithRetry(() => import("../Pages/YarnInventory/ScanCartoon.js"));
const ShadeConsumptionDetail = lazyWithRetry(() => import("../Pages/YarnInventory/ShadeConsumptionDetail.js"));
const UpdateYarnConsumption = lazyWithRetry(() => import("../Pages/YarnInventory/UpdateYarnConsumption.js"));
const WeeklyConsumptionReport = lazyWithRetry(() => import("../Pages/YarnInventory/WeeklyConsumptionReport.js"));
const YarnAdjustmentDetail = lazyWithRetry(() => import("../Pages/YarnInventory/YarnAdjustmentDetail.js"));
const YarnAdjustmentList = lazyWithRetry(() => import("../Pages/YarnInventory/YarnAdjustmentList.js"));
const YarnCartonAdjustmentDetail = lazyWithRetry(() => import("../Pages/YarnInventory/YarnCartonAdjustmentDetail.js"));
const YarnCartonAdjustmentList = lazyWithRetry(() => import("../Pages/YarnInventory/YarnCartonAdjustmentList.js"));
const YarnCartonConsumptionDetail = lazyWithRetry(() => import("../Pages/YarnInventory/YarnCartonConsumptionDetail.js"));
const YarnCartonConsumptionList = lazyWithRetry(() => import("../Pages/YarnInventory/YarnCartonConsumptionList.js"));
const YarnCartonDaySummary = lazyWithRetry(() => import("../Pages/YarnInventory/YarnCartonDaySummary.js"));
const YarnCartonDefaults = lazyWithRetry(() => import("../Pages/YarnInventory/YarnCartonDefaults.js"));
const YarnCartonReorder = lazyWithRetry(() => import("../Pages/YarnInventory/YarnCartonReorder.js"));
const YarnCartonStock = lazyWithRetry(() => import("../Pages/YarnInventory/YarnCartonStock.js"));
const YarnConsumptionDetails = lazyWithRetry(() => import("../Pages/YarnInventory/YarnConsumptionDetails.js"));
const YarnConsumptionList = lazyWithRetry(() => import("../Pages/YarnInventory/YarnConsumptionList.js"));
const YarnInventoryAvailableStock = lazyWithRetry(() => import("../Pages/YarnInventory/YarnInventoryAvailableStock.js"));
const YarnInventoryPendingApprovals = lazyWithRetry(() => import("../Pages/YarnInventory/YarnInventoryPendingApprovals.js"));
const YarnInventoryStock = lazyWithRetry(() => import("../Pages/YarnInventory/YarnInventoryStock.js"));
const YarnMovementReport = lazyWithRetry(() => import("../Pages/YarnInventory/YarnMovementReport.js"));
const YarnRunRate = lazyWithRetry(() => import("../Pages/YarnInventory/YarnRunRate.js"));
const YarnShadeSequence = lazyWithRetry(() => import("../Pages/YarnInventory/YarnShadeSequence.js"));
const YarnShadeSummary = lazyWithRetry(() => import("../Pages/YarnInventory/YarnShadeSummary.js"));
const YarnStockByManufacturer = lazyWithRetry(() => import("../Pages/YarnInventory/YarnStockByManufacturer.js"));
const YarnStockReconciliation = lazyWithRetry(() => import("../Pages/YarnInventory/YarnStockReconciliation.js"));
const YarnTransferDetail = lazyWithRetry(() => import("../Pages/YarnInventory/YarnTransferDetail.js"));
const UpdateYarnPrice = lazyWithRetry(() => import("../Pages/YarnPriceList/UpdateYarnPrice.js"));
const YarnPrice = lazyWithRetry(() => import("../Pages/YarnPriceList/YarnPrice.js"));
const InputYarnQuality = lazyWithRetry(() => import("../Pages/YarnQuality/InputYarnQuality.js"));
const UpdateYarnQuality = lazyWithRetry(() => import("../Pages/YarnQuality/UpdateYarnQuality.js"));
const YarnQuality = lazyWithRetry(() => import("../Pages/YarnQuality/YarnQuality.js"));
const BulkUpdateYarnShade = lazyWithRetry(() => import("../Pages/YarnShade/BulkUpdateYarnShade.js"));
const InputYarnShade = lazyWithRetry(() => import("../Pages/YarnShade/InputYarnShade.js"));
const UpdateYarnShade = lazyWithRetry(() => import("../Pages/YarnShade/UpdateYarnShade.js"));
const YarnShade = lazyWithRetry(() => import("../Pages/YarnShade/YarnShade.js"));

export const componentMap = {
    AccessModule,
    AccessModuleDetails,
    InputAccessModule,
    UpdateAccessModule,
    AccountReportsHub,
    BalanceConfirmations,
    BalanceSheet,
    BankStatement,
    CashBook,
    CashFlow,
    Consolidated,
    DayBook,
    Expenses,
    GlParity,
    OpeningBalance,
    PartyOpeningBalance,
    PayablesAging,
    PaymentRegister,
    ProfitLoss,
    Ratios,
    ReceiptRegister,
    StockValuation,
    SupplierLedger,
    TrialBalance,
    KeyPersonRisk,
    ScheduledJobs,
    UsageAnalytics,
    Agent,
    InputAgent,
    UpdateAgent,
    AccountsApprovals,
    AdjustmentApprovalsSection,
    CreditOverrideApprovals,
    PendingApprovals,
    Bank,
    InputBank,
    UpdateBank,
    BankReconciliation,
    ChequeRegister,
    PaymentRun,
    BlouseStitchDetail,
    BlouseStitchList,
    InputBlouseStitch,
    BusinessUnit,
    BulkUpdateCatalogue,
    Catalogue,
    DetailsCatalogue,
    InputCatalogue,
    UpdateCatalogue,
    CatalogueDescription,
    InputCatalogueDescription,
    CatalogueMatching,
    CatalogueMatchingApprovals,
    DetailsCatalogueMatching,
    InputCatalogueMatching,
    UpdateCatalogueMatching,
    CatalogueSaleColours,
    DetailsCatalogueSaleColour,
    InputCatalogueSaleColour,
    UpdateCatalogueSaleColour,
    ChangePassword,
    DashboardScopeCard,
    TaxCompliance,
    AddSimilarCostDesign,
    CostDesign,
    DetailsCostDesign,
    InputCostDesign,
    UpdateCostDesign,
    CreditNoteDetail,
    CreditNoteList,
    InputCreditNote,
    PrintCreditNote,
    UpdateCreditNote,
    AgingChart,
    Dashboard,
    DashboardCard,
    GoodsReturnChart,
    InventoryStageChart,
    LoomPicksChart,
    SalesTrendChart,
    TopClientsTable,
    YarnRunwayChart,
    YarnStockChart,
    DebitNoteDetail,
    DebitNoteList,
    InputDebitNote,
    PrintDebitNote,
    DefectCodes,
    DefectPareto,
    AddSimilarDesign,
    BulkUpdateDesigns,
    Design,
    DesignApprovals,
    DetailsDesign,
    InputDesign,
    SampleTrialCard,
    UpdateDesign,
    ArticleRenderer,
    Docs,
    DyeingDetail,
    DyeingList,
    InputDyeing,
    DyeingRecipeDetail,
    DyeingRecipes,
    InputDyeingRecipe,
    UpdateDyeingRecipe,
    EfficiencyReport,
    EfficiencyReportList,
    OperatorPerformance,
    Firm,
    FirmBankAccounts,
    InputFirm,
    UpdateFirm,
    FlowBoard,
    EwayRegister,
    GSTR1Report,
    GSTR2Report,
    GSTR3BReport,
    GSTR9Report,
    GSTReconciliation,
    GSTReportPage,
    GSTReportsHub,
    TdsTcsRegister,
    DownloadButtonGroup,
    GSTReportFilters,
    Harness,
    InputHarness,
    UpdateHarness,
    Home,
    HsnCode,
    InputHsnCode,
    UpdateHsnCode,
    BulkPrintInternalTransfer,
    InputInternalTransfer,
    InputInternalTransferFromPO,
    InternalTransferDetail,
    InternalTransfers,
    PrintInternalTransfer,
    UpdateInternalTransfer,
    DesignInventory,
    LocationInventory,
    ProductionPipeline,
    StagePipeline,
    VendorStock,
    BulkPrintInwardRegister,
    InputInwardRegister,
    InputInwardRegisterFromOutward,
    InwardRegisterDetail,
    InwardRegisters,
    InwardReport,
    PrintInwardRegister,
    UpdateInwardRegister,
    InputJournalVoucher,
    JournalVoucherDetails,
    JournalVoucherList,
    PrintJournalVoucher,
    LedgerAccounts,
    DetailsLocation,
    InputLocation,
    Location,
    UpdateLocation,
    Login,
    ColumnLayoutEditor,
    InputLoomShade,
    LoomShade,
    UpdateLoomShade,
    MCSImport,
    BulkLoomShade,
    InputMachine,
    Machine,
    MachineDetails,
    UpdateMachine,
    BulkUpdateMatchings,
    DesignMatching,
    InputMatching,
    InputMatchingTable,
    MatchingApprovals,
    MatchingTable,
    SingleMatching,
    UpdateMatching,
    InputMatchingCode,
    MatchingCode,
    UpdateMatchingCode,
    NotFound,
    InputOperator,
    Operator,
    UpdateOperator,
    DownstreamFlow,
    InputOrderbook,
    OrderbookDetails,
    Orderbooks,
    UpdateOrderbook,
    InputOutwardChallan,
    OutwardChallanDetail,
    OutwardChallans,
    PrintOutwardChallan,
    UpdateOutwardChallan,
    BulkEwayJobWork,
    BulkPrintOutwardRegister,
    DeliveryReport,
    EditOutwardRemarksModal,
    InputOutwardRegister,
    InputOutwardRegisterFromPO,
    InputOutwardRegisterFromRegister,
    InputOutwardRegisterMultiPO,
    OutwardRegisterDeliveries,
    OutwardRegisterDetail,
    OutwardRegisters,
    PrintOutwardRegister,
    UpdateOutwardRegister,
    OutwardWorkTypes,
    BulkPartyContacts,
    InputParty,
    Party,
    PartyDetail,
    UpdateParty,
    InputPaymentVoucher,
    PaymentVoucherDetail,
    PaymentVoucherList,
    PrintPaymentVoucher,
    ReconcilePaymentVoucher,
    SuspendedVouchers,
    UpdatePaymentVoucher,
    BillAllocationGrid,
    NoteApplyGrid,
    AddPendingParty,
    PendingParty,
    InputPhotoshoot,
    Photoshoot,
    PhotoshootEditor,
    OrderPhotoshoot,
    InputProcessingRecipe,
    ProcessingRecipeDetail,
    ProcessingRecipes,
    UpdateProcessingRecipe,
    BulkCancelProductionOrder,
    BulkCancelProductionOrderHistory,
    BulkPrintProductionOrder,
    CloseProductionOrder,
    CompletedProductionOrders,
    GradeProductionOrder,
    InputProductionOrder,
    PrintProductionOrder,
    PrintUngradedGradingSheet,
    ProductionCompletedForm,
    ProductionOrderDetail,
    ProductionOrders,
    UngradedInventory,
    UpdateCloseProductionOrder,
    UpdateProductionOrder,
    BulkAddMachineProgram,
    BulkCloseMachineProgram,
    BulkCloseMachineProgramHistory,
    CloseMachineProgram,
    ClothRollCompletion,
    ClothRollCompletionList,
    DetailMachineProgramReport,
    InputMachineProgram,
    InputMachineProgramOrderDirect,
    MachineProgram,
    MachineProgramOrderEditor,
    MachineProgramReport,
    MachineProgramRunSelection,
    MachineProgramRunSelectionList,
    MachineProgramRunSelectionPrint,
    PrintMachineProgram,
    PrintPOMachineProgram,
    PrintSingleMachineProgram,
    PrintSummaryMachineProgram,
    TransferMachineProgram,
    TransferMultipleMachineProgram,
    CombinePurchaseBill,
    InputPurchaseBill,
    PrintPurchaseBill,
    PurchaseBill,
    PurchaseBillDetail,
    PurchaseBillFromChallans,
    UpdatePurchaseBill,
    VerifyPurchaseBillDraft,
    InputPurchaseChallan,
    PrintPurchaseChallan,
    PurchaseChallan,
    PurchaseChallanDetails,
    UpdatePurchaseChallan,
    DetailPetaOrder,
    DetailPurchaseOrder,
    InputPetaOrder,
    InputPurchaseOrder,
    PetaOrder,
    PrintPurchaseOrder,
    PurchaseOrder,
    UpdatePetaOrder,
    UpdatePurchaseOrder,
    InputQRAudit,
    InputQRLocationAudit,
    QRAuditDetail,
    QRAudits,
    BulkPrintQRInternalTransfer,
    InputQRInternalTransfer,
    PrintQRInternalTransfer,
    PrintQRInternalTransferLabels,
    QRInternalTransferDetail,
    QRInternalTransfers,
    ReceiveQRInternalTransfer,
    UpdateQRInternalTransfer,
    BulkPrintQRInwardRegister,
    InputQRInwardRegister,
    PrintQRInwardRegister,
    PrintQRInwardRegisterLabels,
    QRInwardRegisterDetail,
    QRInwardRegisters,
    QRInwardReport,
    UpdateQRInwardRegister,
    InputQRMigration,
    QRMigrationDetail,
    QRMigrations,
    BulkPrintQROutwardRegister,
    InputQROutwardRegister,
    InputQROutwardRegisterFromRegister,
    PrintQROutwardRegister,
    PrintQROutwardRegisterLabels,
    QRDeliveryReport,
    QROutwardRegisterDeliveries,
    QROutwardRegisterDetail,
    QROutwardRegisters,
    UpdateQROutwardRegister,
    MarkVoided,
    ScanTimer,
    InputQRStockAdjustment,
    QRStockAdjustmentDetail,
    QRStockAdjustments,
    InputQRStockDeduction,
    QRStockDeductionDetail,
    QRStockDeductions,
    ApprovedQuality,
    DetailsQuality,
    InputQuality,
    Quality,
    UpdateQuality,
    RackDetail,
    Racks,
    AgentCommission,
    LateInterest,
    PaymentReminders,
    CatalogueStock,
    Replenishment,
    ReplenishmentRequestView,
    ReplenishmentSettings,
    ShopStock,
    InputRole,
    Role,
    RoleDetails,
    UpdateRole,
    BulkEwaySalesBill,
    BulkPrintSalesBill,
    InputSalesBill,
    PrintSalesBill,
    SalesBill,
    SalesBillDetail,
    TransportReceipts,
    UpdateSalesBill,
    BillDetailsCard,
    BillSummary,
    LineItemsTable,
    BulkPrintSalesChallan,
    InputSalesChallan,
    PrintSalesChallan,
    SalesChallan,
    SalesChallanDetail,
    UpdateSalesChallan,
    AmendSalesOrder,
    BulkPrintPendingSalesOrder,
    ClosedSalesOrders,
    InputSalesOrder,
    PendingDesignsByCatalogue,
    PendingDesignsByParty,
    PendingSalesOrders,
    PickListByRack,
    PrintPartyPendingSaree,
    PrintPendingSaree,
    PrintSalesOrder,
    QuickColourToggle,
    ReadyToDispatch,
    SalesOrder,
    SalesOrderBulkActions,
    SalesOrderDesignTable,
    SalesOrderDetail,
    SalesOrderQrScan,
    UpdateSalesOrder,
    AgentPerformance,
    CatalogueWiseSales,
    ChallanRegister,
    ClothRollProductionReport,
    ClothRollProductionTrendChart,
    DayWiseRollOpenedSection,
    EndOfDaySummary,
    FYSummary,
    FirmWiseComparison,
    GSTSummary,
    GoodsMovementReport,
    OrderBook,
    OutstandingReport,
    PartyCatalogueMessage,
    PartyLedger,
    PaymentCollection,
    PeriodicSummary,
    ProductionOrderReport,
    ProductionOutputReport,
    ProductionReport,
    ReceivablesAging,
    SalesBillRegister,
    SalesmanPerformance,
    SecondsReport,
    TodayProductionReport,
    AmendSalesReturn,
    BulkPrintSalesReturn,
    ChargeGstSelect,
    DisputeResolutionModal,
    InputSalesReturn,
    PartyGrNotes,
    PrintSalesReturn,
    PrintSalesReturnLabels,
    SalesReturn,
    SalesReturnApprovals,
    SalesReturnDetail,
    UpdateSalesReturn,
    AmendSalesSet,
    InputSalesSet,
    SalesSetList,
    InputSalesman,
    Salesman,
    UpdateSalesman,
    DetailsSample,
    InputSample,
    PrintSample,
    Sample,
    UpdateSample,
    InputSareeCategory,
    SareeCategory,
    UpdateSareeCategory,
    AddSecondsBatch,
    PrintSecondsBatch,
    SecondsBatchDetails,
    SecondsBatchList,
    SessionExpired,
    AmendSetTemplate,
    DetailsSetTemplate,
    InputSetTemplate,
    SetTemplateList,
    SopRuns,
    SopTemplateEditor,
    SopTemplates,
    InputStitchTemplate,
    StitchTemplateDetail,
    StitchTemplates,
    UpdateStitchTemplate,
    CatalogueMatchingBlock,
    ComponentConsumptionSummary,
    InputStitchingInward,
    StitchingInwardDetail,
    StitchingInwardList,
    UpdateStitchingInward,
    AddStockAdjustment,
    DeductStockAdjustment,
    InputStockAdjustment,
    StockAdjustmentDetail,
    StockAdjustments,
    UpdateStockAdjustment,
    ZeroStockAtLocationModal,
    RegradeStock,
    StockRegradeDetail,
    StockRegradeList,
    InputTransport,
    Transport,
    UpdateTransport,
    BulkRegradeUnitQR,
    CorrectUnitQR,
    GenerateQR,
    GenerateQRFromRegister,
    GeneratedQRDetail,
    GeneratedQRList,
    PrintGeneratedQR,
    PrintUnitQR,
    PrintUnitQRLabels,
    RegradeUnitQR,
    ScanQR,
    UnitQRList,
    UnitQRTag,
    InputUser,
    UpdateUser,
    User,
    UserPermissions,
    InputValueAddition,
    UpdateValueAddition,
    ValueAddition,
    InputVendorProcessing,
    UpdateVendorProcessing,
    VendorProcessingDetail,
    VendorProcessingList,
    VendorRegister,
    AddVendorStockAdjustment,
    DeductVendorStockAdjustment,
    InputVendorStockAdjustment,
    UpdateVendorStockAdjustment,
    VendorStockAdjustmentDetail,
    VendorStockAdjustments,
    ZeroStockByCatalogueModal,
    ZeroStockByDateModal,
    InputWarpDesignColour,
    UpdateWarpDesignColour,
    WarpDesignColour,
    InputWarpPattern,
    UpdateWarpPattern,
    WarpPattern,
    WarpPatternForm,
    DetailsWarpbeam,
    InputWarpbeam,
    PrintWarpbeam,
    UpdateWarpbeam,
    Warpbeam,
    WarpbeamForm,
    AttachPreview,
    ChatList,
    ChatThread,
    Composer,
    ContactPanel,
    MediaViewer,
    MessageBubble,
    MessageInfo,
    QuickRepliesManager,
    ShortcutsHelp,
    WhatsAppInbox,
    SendInvoices,
    SendTransportReceipts,
    BulkAddCartoon,
    BulkConsumeCartoon,
    BulkDeleteCartoon,
    CartoonAuditTrail,
    CartoonList,
    CartoonQualityShadeAudit,
    InputCartoonLocationAudit,
    InputSupplierReturn,
    InputYarnCartonAdjustment,
    InputYarnCartonConsumption,
    InputYarnCartonConsumptionSheet,
    InputYarnConsumption,
    InputYarnConsumptionByCartoon,
    InputYarnSale,
    InputYarnTransfer,
    MonthlyPurchaseReport,
    PrintCartoonLabels,
    PrintYarnAdjustment,
    PrintYarnCartonDaySummary,
    PrintYarnCartonStock,
    RegisterYarnReceipt,
    RunRateProblemChart,
    RunRateProjectionChart,
    ScanCartoon,
    ShadeConsumptionDetail,
    UpdateYarnConsumption,
    WeeklyConsumptionReport,
    YarnAdjustmentDetail,
    YarnAdjustmentList,
    YarnCartonAdjustmentDetail,
    YarnCartonAdjustmentList,
    YarnCartonConsumptionDetail,
    YarnCartonConsumptionList,
    YarnCartonDaySummary,
    YarnCartonDefaults,
    YarnCartonReorder,
    YarnCartonStock,
    YarnConsumptionDetails,
    YarnConsumptionList,
    YarnInventoryAvailableStock,
    YarnInventoryPendingApprovals,
    YarnInventoryStock,
    YarnMovementReport,
    YarnRunRate,
    YarnShadeSequence,
    YarnShadeSummary,
    YarnStockByManufacturer,
    YarnStockReconciliation,
    YarnTransferDetail,
    UpdateYarnPrice,
    YarnPrice,
    InputYarnQuality,
    UpdateYarnQuality,
    YarnQuality,
    BulkUpdateYarnShade,
    InputYarnShade,
    UpdateYarnShade,
    YarnShade,
};
